import { render, staticRenderFns } from "./QuillViewer.vue?vue&type=template&id=c6a1e2d6&"
import script from "./QuillViewer.vue?vue&type=script&lang=js&"
export * from "./QuillViewer.vue?vue&type=script&lang=js&"
import style0 from "./QuillViewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports